export function filterChip(v, label) {
  if (v[0] && !v[1]) {
    return `Min ${label}: ${v[0]}`;
  }
  if (!v[0] && v[1]) {
    return `Max ${label}: ${v[1]}`;
  }
  if (v[0] && v[1]) {
    return `Min ${label}: ${v[0]}, Max ${label}: ${v[1]}`;
  }
  return [];
}

export function filterLogic(value, filters) {
  value = Number(value);
  if (filters[0] && filters[1] && value < Number(filters[0]) && value > Number(filters[1])) {
    return true;
  } else if (filters[0] && value < Number(filters[0])) {
    return true;
  } else if (filters[1] && value > Number(filters[1])) {
    return true;
  }

  return false;
}

export function maxfilterChip(v, label) {
  if (v[0]) {
    return `Max ${label}: ${v[0]}`;
  }
  return [];
}

export function maxFilterLogic(value, filters) {
  value = Number(value);

  return filters[0] && Number(filters[0]) > value;
}
